import { z } from 'zod';
import { KpiPeriodSchema } from './kpi.js';
export const SparklinePointSchema = z.object({
    date: z.string(), // YYYY-MM-DD
    value: z.number().int(),
});
export const AchievementsSchema = z.object({
    outreachCur: z.number().int(),
    outreachPrv: z.number().int(),
    movesCur: z.number().int(),
    movesPrv: z.number().int(),
    reachedCur: z.number().int(),
    reachedPrv: z.number().int(),
    winsCur: z.number().int(),
    winsPrv: z.number().int(),
});
export const BestLocationSchema = z.object({
    id: z.number().int(),
    name: z.string(),
    untouched: z.number().int(),
    total: z.number().int(),
});
export const TopAgentRowSchema = z.object({
    agentId: z.number().int(),
    agentName: z.string(),
    areasCovered: z.number().int(),
    calls: z.number().int(),
    whatsapps: z.number().int(),
    stageMoves: z.number().int(),
    wins: z.number().int(),
    reached: z.number().int(),
    lastActive: z.string().nullable(),
    sparkline: z.array(SparklinePointSchema),
});
export const RecentlyTouchedSchema = z.object({
    landlordId: z.number().int(),
    landlordName: z.string(),
    building: z.string().nullable(),
    areaName: z.string().nullable(),
    stage: z.string(),
    lastActivityType: z.string(),
    lastActivityAt: z.string(),
    agentName: z.string().nullable(),
});
export const AdminDashboardSchema = z.object({
    period: KpiPeriodSchema,
    achievements: AchievementsSchema,
    bestLocations: z.array(BestLocationSchema),
    topAgents: z.array(TopAgentRowSchema),
    recentlyTouched: z.array(RecentlyTouchedSchema),
});
// Manager dashboard — same shape as admin, scoped to manager_areas
export const ManagerDashboardSchema = AdminDashboardSchema.extend({
    areaIds: z.array(z.number().int()),
});
//# sourceMappingURL=dashboard.js.map